const Subscription = () => {
  return (
    <div>
      <h3>This is the Subscription page</h3>
    </div>
  );
};

export default Subscription;
